import { CSSProperties } from 'react'
import { QuickAction } from 'Hooks/useMaestroChat'
import { styx, clsx } from 'modules/Utils'
import Colors from 'modules/Colors'
import ButtonSymphony, { ButtonColor } from 'elements/ButtonSymphony'

// QuickActions component to render quick action buttons
const QuickActions = ({
    actions,
    onActionClick
}: {
    actions: QuickAction[],
    onActionClick: (action: QuickAction) => void
}) => {
    if (!actions || actions.length === 0) {
        return null
    }

    // Define the color cycle
    const colorCycle: ButtonColor[] = ['purple', 'green', 'purpleLight', 'gold']

    return (
        <div className="quickActionsContainer" style={sty.quickActionsContainer}>
            {actions.map((action, index) => {
                const buttonColor = colorCycle[index % colorCycle.length]
                
                return (
                    <ButtonSymphony
                        key={action.id}
                        className="quickActionButton"
                        color={buttonColor}
                        style={styx(
                            sty.quickActionButton,
                            { animationDelay: `${index * 100}ms` }
                        )}
                        onClick={() => onActionClick(action)}
                    >
                        {action.label}
                    </ButtonSymphony>
                )
            })}
        </div>
    )
}

export default QuickActions

const sty: Record<string, CSSProperties> = {
    quickActionsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8,
        animation: 'fadeInUp 0.3s ease-out',
    },
    quickActionButton: {
        border: 'none',
        padding: '12px 20px',
        borderRadius: 8,
        cursor: 'pointer',
        fontWeight: 500,
        fontSize: 14,
        transition: 'all 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        animation: 'fadeInUp 0.3s ease-out',
        animationFillMode: 'both',
    },
}